import {FETCH_USER_TOKEN, SUBSCRIBE} from '../actions';

import cookie from 'react-cookies';

export default function (state={}, action){
  switch(action.type){
    case FETCH_USER_TOKEN:
      let userToken = action.payload.data.token;
      cookie.save('userToken', userToken, {path:'/'});
      return userToken;
    case SUBSCRIBE:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_usertoken.js